<template>
  <div style="width: 100%;height: 380px;position:relative;z-index: 77;">
    <HomeChartBlock refId="Highcharts6" :option="option"></HomeChartBlock>
  </div>
</template>

<script>
import Highcharts from 'highcharts/highstock';
import cylinder from "highcharts/modules/cylinder";
import HighchartsMore from 'highcharts/highcharts-more';
import HighchartsDrilldown from 'highcharts/modules/drilldown';
import Highcharts3D from 'highcharts/highcharts-3d';

HighchartsMore(Highcharts)
HighchartsDrilldown(Highcharts);
Highcharts3D(Highcharts);
cylinder(Highcharts);

import HomeChartBlock from './HomeChartBlock'
import { parseNumber } from '@/utils'
export default {
  props: {
    item: {
      type: Array,
      default: []
    }
  },
  components: {
    HomeChartBlock
  },
  data() {
    return {

    }
  },
  computed: {
    option() {

      let tickAmount = 0
      for (let i = 0; i < this.item.length; i++) {
        let value = parseNumber(this.item[i].value)
        if (value >= tickAmount) {
          tickAmount = value
        }
      }

      let dataOld = {
        credits: {
          enabled: false
        },
        exporting: {
          enabled: false
        },
        chart: {
          marginLeft: 60,
          marginBottom: 60,
          panning: true,
          type: 'cylinder',
          backgroundColor: null,
          spacing: [30, 10, 10, 10],
          options3d: {
            enabled: true,
            alpha: 16,
            beta: 0,
            depth: 0
          },
          resetZoomButton: {
            enabled: false,
            theme: {
              display: 'none'
            }
          }
        },
        colors: ["#fe8903"],
        title: {
          text: ''
        },
        tooltip: {
          shared: true,
          valueSuffix: '',
          backgroundColor: {
            linearGradient: [0, 0, 0, 60],
            stops: [
              [0, '#027EC0'],
              [1, '#03FBFE']
            ]
          },
          borderWidth: 1,
          borderColor: '#03FBFE',
          shadow: true,
          padding: 10,
          formatter: function (data) {
            let str =
              '<div style="width: 100%;display: block;">'
              + '<div style="width: 100%;display: block;font-size: 11px;color: #100f0f;font-weight: 400;">' + this.x + '-数量</div>'
              + '</br>'
              + '<div style="width: 100%;display: block;font-size: 27px;color: #0e0d0d;font-weight: bold;">' + this.y + '</div>'
              + '</div>'
            return str
          }
        },
        //4.设置滚动条可用
        scrollbar: {
          enabled: true,
          minWidth: 0,
          margin: 0,
          barBackgroundColor: 'rgba(23, 139, 226, 0.5)',
          showFull: false,//当滚动的内容被完全缩小时，是显示还是隐藏滚动条。
        },
        xAxis: {
          // gridLineColor: "#21658a",
          gridLineWidth: 0,
          lineColor: "#17317F",
          gridLineColor: "#17317F",
          categories: Array.isArray(this.item) ? this.item.map((item, index) => {
            return item.name
          }) : [],
          labels: {
            style: {
              color: "#0e0d0d",
              fontSize: 11
            },
            // autoRotation: false,//是否可以自动斜体
            useHTML: false,
            formatter: function () {
              // return '<a href="' + categoryLinks[this.value] + '">' +
              //   this.value + '</a>';
              // 获取到刻度值
              let labelVal = this.value;
              let ret = ""; // 拼接加\n返回的类目项
              let maxLength = 1000; // 每项显示文字个数
              let valLength = labelVal.length; // X轴类目项的文字个数
              let rowN = Math.ceil(valLength / maxLength); // 类目项需要换行的行数
              // 如果类目项的文字大于3,
              if (rowN > 1) {
                for (let i = 0; i < rowN; i++) {
                  let temp = ""; // 每次截取的字符串
                  let start = i * maxLength; // 开始截取的位置
                  let end = start + maxLength; // 结束截取的位置
                  temp = labelVal.substring(start, end) + "<br/>";
                  ret += temp; // 凭借最终的字符串
                }
                return ret;
              } else {
                return labelVal;
              }
            }
          }
        },
        yAxis: {
          title: {
            text: '作业票',
            align: 'high',
            rotation: 0,
            x: 40,
            y: -20,
            style: { "color": "#0e0d0d" }
          },
          gridLineColor: "#17317F",
          tickAmount: tickAmount > 0 ? undefined : 5,
          labels: {
            style: {
              color: "#0e0d0d",
              fontSize: 10
            }
          }
        },

        plotOptions: {
          series: {
            colorByPoint: true
          },
          areaspline: {
            fillOpacity: 0.5
          },

          area: {
            fillColor: {
              linearGradient: {
                x1: 0,
                y1: 0,
                x2: 0,
                y2: 1
              },
              stops: [
                [0, '#00D361'],
                [1, new Highcharts.Color('#00D361').setOpacity(0).get('rgba')]
              ]
            },
            marker: {
              radius: 2
            },
            lineWidth: 1,
            states: {
              hover: {
                lineWidth: 1
              }
            },
            threshold: null
          }
        },

        series: [{
          name: "",
          colorByPoint: true,
          data: Array.isArray(this.item) ? this.item.map((item, index) => {
            return parseNumber(item.value)
          }) : [],
          showInLegend: false,
          borderWidth: 0,
          pointWidth: 27,
          // 每根柱子上显示数量文字
          dataLabels: {
            enabled: false,
            // distance: -20,
            style: {
              textOutline: "0px 0px contrast",
              color: "#0e0d0d",
              fontSize: 16
            },
            format: '{y}'
          }
        }]
      }
      return dataOld
    }
  },

  created() {


  },
  mounted() {

  },
  beforeDestroy() {

  },
  methods: {

  }
}
</script>

<style lang="scss" scoped>
.home-ticket-mian {
  width: 90%;
}
</style>
 
.schedule-rogress {
  width: 92%;
  height: 19px; 
  margin-bottom: 35px;
  display: block;


  .el-progress__text {
    font-size: 16px !important;
    font-family: PingFang SC;
    font-weight: 500;
    color: #FFFFFF !important;
    margin-left: 20px;
  }

  /*.el-progress-bar__outer {
    background: linear-gradient(0deg, rgba(0, 158, 249, 0.3), rgba(130, 235, 255, 0.3), rgba(6, 150, 233, 0.3));
  }*/

  .el-progress-bar__inner {
    background: linear-gradient(0deg, rgba(0, 158, 249, 0.7), rgba(130, 235, 255, 0.7), rgba(6, 150, 233, 0.7));
  }
}

.schedule-rogress2{
  .el-progress-bar__inner {
    background: linear-gradient(0deg, rgba(219,175,0, 0.7), rgba(255,239,130, 0.7), rgba(227,181,0, 0.7));
  }
}
</style>